// extracted by mini-css-extract-plugin
module.exports = {"copy":"copy_copy__Xt5hl","copyBlock":"copy_copyBlock__33-aF"};